<div class="d-flex justify-content-between align-items-center mg-t-20">
  <div class="footer-left"><span>{{i18nLabel.total | translate}} {{total}} {{i18nLabel.item | translate}} {{i18nLabel.record | translate}}</span></div>
  <nz-pagination [nzPageIndex]="pageParams.page" [nzPageSize]="pageParams.size" [nzTotal]="total"
    [nzPageSizeOptions]="[10,20,30,40,50,100,200]" (nzPageIndexChange)="pageChange($event)"
    (nzPageSizeChange)="pageSizeChange($event)" nzShowQuickJumper nzShowSizeChanger>
  </nz-pagination>
</div>
